import {
  markLotAsReceivedType,
  markLotAsReceivedSuccessType,
  markLotAsReceivedFailureType,
} from 'actions/Lots/markLotAsReceived';

const INITIAL_STATE = {
  isPending: false,
};

const markLotAsReceivedReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case markLotAsReceivedType:
      return {
        isPending: true,
      };
    case markLotAsReceivedSuccessType:
    case markLotAsReceivedFailureType:
      return {
        isPending: false,
      };
    default:
      return state;
  }
};

export { markLotAsReceivedReducer };
